import { render } from 'preact';
import { App } from './App';
import { ErrorBoundary, initGlobalErrorHandler } from './components/ErrorBoundary';
import './styles.css';

if (typeof window !== 'undefined') {
  initGlobalErrorHandler();
}

const root = document.getElementById('app');
if (root) {
  render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
    root,
  );
}
